import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../../core/et3-input/et3-text-input";
import getKhattabat101CStore from "../../../../../../../stores/khattabat-stores/101c-stores";

const CreateOneOTwoField = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { theme, userID } = props;
  const { unitX, unitY } = theme;
  const { insertUserIdField } = getKhattabat101CStore(userID);

  return (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        borderRadius: 36 * unitX,
        cursor: "pointer",
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={true}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3TextInput
        size="SMALL"
        withShadow={false}
        placeHolder={"Insert User ID"}
        icon={"function"}
        label={""}
        style={{
          width: 180 * unitX,
          height: 43 * unitY
        }}
        value={insertUserIdField.get()}
        onChoose={(fieldValue: number) => {
          insertUserIdField.set(fieldValue);
        }}
        onBlur={() => {}}
        type={"number"}
        onEnter={() => {}}
      />
    </ET3Div>
  );
});

export default CreateOneOTwoField;
